import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * Term chip (design system atom).
 *
 * Fixed-size card that displays a term/plan label on top and an optional price
 * sub-label underneath. It is a purely presentational control: it renders a
 * visual state and emits a click; it holds no business logic and persists
 * nothing. Compose several of these (see `ds-term-selector`) to build a
 * single-select row of terms.
 *
 * Figma spec (Term chip): vertical layout, center aligned, 12px bold label,
 * conditional price sub-label, states Default / Selected / Disabled (+ hover
 * and focus handled via CSS).
 */
@Component({
  selector: "ds-term-chip",
  templateUrl: "./ds-term-chip.component.html",
  styleUrls: ["./ds-term-chip.component.scss"],
})
export class DsTermChipComponent {
  /** Label shown on the top half (e.g. "24 meses"). */
  @Input() label = "";

  /** Formatted price shown underneath (e.g. "$185.00"). Only rendered when `showPrice` is true. */
  @Input() amount = "";

  /** Toggles the price sub-label. Matches the Figma `showPrice` prop. */
  @Input() showPrice = false;

  /** Active visual state (Figma `state`: Default | Selected). */
  @Input() selected = false;

  @Input() disabled = false;

  /** Emitted on click (Figma `onClick`). Selection state is owned by the parent. */
  @Output() chipClick = new EventEmitter<void>();

  onClick(): void {
    if (this.disabled) return;
    this.chipClick.emit();
  }
}
